const createType = (perfix: string) => {
    return {
        REQUEST: perfix + '_REQUEST',
        SUCCESS: perfix + '_SUCCESS',
        FAILED: perfix + '_FAILED'
    };
};

// export const SEARCH_CUSTOMER_NAME = createType('SEARCH_CUSTOMER_NAME');
export const DOC_INFO = createType('DOC_INFO');
export const DOC_DOWNLOAD = createType('DOC_DOWNLOAD');
export const DOC_TOKEN = createType('DOC_TOKEN');
export const DOC_OSSURL = createType('DOC_OSSURL');
export const DOCCATALOG = createType('DOCCATALOG');
export const CATEGORY = createType('CATEGORY');
export const PRODUCTCATEGORY = createType('PRODUCTCATEGORY');
export const IDPRODUCTCATEGORY = createType('IDPRODUCTCATEGORY');
export const IDPRODUCTCATEGORYMESSAGE = createType('IDPRODUCTCATEGORYMESSAGE');
export const PRAISE_DOC_META = createType('PRAISE_DOC_META');
export const CANCEL_PRAISE_DOC_META = createType('CANCEL_PRAISE_DOC_META');
export const DOC_HOMELIST = createType('DOC_HOMELIST');
export const DOC_HOMELIST_PAR = createType('DOC_HOMELIST_PAR');
export const DOC_VIEWED = createType('DOC_VIEWED');
export const HOT_WORDS = createType('HOT_WORDS');
export const SYS_LIST = createType('SYS_LIST');
